/**
 * 用户类型筛选器组件
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { Select } from 'tea-component';
import { IUserTypeProps, TUserType } from './types';
import { LANGUAGE_EN } from '@home/_config/config';
import './index.scss';

const DEFAULT_USER_TYPE: TUserType = 'new_user';

const UserType: React.FC<IUserTypeProps> = (props) => {
  const { className, title, required, value, onChange } = props;
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const [selectedValue, setSelectedValue] = useState<TUserType>(
    value || DEFAULT_USER_TYPE
  );

  // 同步外部传入的 value 到内部状态
  useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);

  // 使用国际化生成选项
  const userTypeOptions = useMemo(() => {
    return [
      {
        value: 'active',
        text: formatMessage({ id: 'dbl_ab_experiment_user_type_active_user' }),
      },
      {
        value: 'new_user',
        text: formatMessage({ id: 'dbl_ab_experiment_user_type_new_user' }),
      },
      {
        value: 'old_user',
        text: formatMessage({ id: 'dbl_ab_experiment_user_type_old_user' }),
      },
    ];
  }, [formatMessage]);

  const handleChange = (newValue: string): void => {
    const userType = newValue as TUserType;
    setSelectedValue(userType);
    onChange?.(userType);
  };

  return (
    <div className={classNames('dbl-user-type', className)}>
      {title && (
        <div
          className={classNames('dbl-user-type-title', {
            'is-required': required,
            'dbl-user-type-title-en': isEn,
          })}
        >
          {title}
        </div>
      )}
      <Select
        appearance="button"
        className="dbl-user-type-select"
        options={userTypeOptions}
        matchButtonWidth
        value={selectedValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default UserType;
